"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFS = void 0;
exports.IFS = {
    alias: 'SES',
    description: 'Permite fazer comparações lógicas e escolher o primeiro valor onde a condição é verdadeira.',
    arg_names: ['condições_valores'],
    args_description: [
        'Pares de condição e valor que serão avaliados',
    ],
    replacements: [
        {
            TRUE: 'VERDADEIRO',
            FALSE: 'FALSO',
        },
        null,
        null,
    ],
};
